import React, { Component, } from 'react'
import { Collapse, Input, Row, Col, Button, } from 'reactstrap'

/*
  <SetRawToScaleScoringForm
    sets={this.props.sets}
    activeSet={this.props.activeSet}
    rawToScaleScoring={this.state.rawToScaleScoring}
  />
*/
/*
  rawToScaleScoring schema = {
    0: 1,
    1: 2,
    2: 2,
    ...
  }

*/


class SetRawToScaleScoringForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      collapse: false,
    }

  }

  toggleCollapse() {
    this.setState({
      collapse: !this.state.collapse
    })
  }

  render() {
    const toggleClosed = (
      <div 
        className='m2clickable' 
        onClick={() => this.toggleCollapse()}
      >
        <p>Raw to Scale Scoring <i className='fa fa-angle-double-right'></i></p>
      </div>)
    const toggleOpened = (
      <div 
        className='m2clickable' 
        onClick={() => this.toggleCollapse()}
      >
        <p>Raw to Scale Scoring <i className='fa fa-angle-double-down'></i></p>
      </div>
    )

    let scaleInputs = []
    for (var i = 0; i <= this.props.maxRaw; i++) {
      let val
      if (this.props.rawToScaleScoring[i]) {
        val = this.props.rawToScaleScoring[i]
      } else {
        val = 0
      }
      const n = parseInt(i)
      scaleInputs.push(
        <Row key={`scaleInput${i}`}>
          <Col xs='1'>{`${i}: `}</Col>
          <Col xs='11'>
            <Input
              value={val}
              onChange={(e) => {
                this.props.handleChangeRawToScaleScoring(n, e.target.value)
              }}
            />
          </Col>
        </Row>
      )

    }


    if (this.props.sets && this.props.activeSet) {
      const thisSet = this.props.sets[this.props.activeSet]
    }


    return (
      <div>
        {this.state.collapse ? toggleOpened : toggleClosed}
        <Collapse
          isOpen={this.state.collapse}
        >
          {scaleInputs}

        </Collapse>
      </div>
    )
  }
}

export default SetRawToScaleScoringForm



// WEBPACK FOOTER //
// ./src/components/Content/ManageSetsComponents/SetRawToScaleScoringForm.js